export const CompanyType = {
  Customer: 1,
  Supplier: 2,
}
